export default __webpack_public_path__ + "static/renesas-qcstudio-b9560d1c94f71792efe8fe429f0cfcdb.png";